import classes from "./about.module.css";

const AboutText = (props) => {
  return (
    <div className={classes.aboutComponent}>
      <p>About Me</p>
      <div className={classes.aboutText}>
        {props.aboutText}
      </div>
    </div>
  );
};

export default AboutText;
